import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

const Contact = () => {
    const [contact, setcontact] = useState([])
    useEffect(() => {
        fetch('Location.json')
            .then(res => res.json())
            .then(data => setcontact(data))
    }, [])

    return (
        <div>
            <h2 className='text-center font-bold text-3xl  text-orange-700'>Contact Us </h2>
            <div className="h-96 w-[95vw] m-auto  carousel-vertical rounded-box grid grid-cols-1 lg:grid-cols-4 border">
                {
                    contact?.map(data => <>

                        <div>
                            <div className="modal-box ">
                                <div className='flex items-center'>
                                    <p className='font-bold'>Phone : </p>  <p className="py-4">{data.phone}</p>
                                </div>
                                <h3 className="text-lg font-bold">{data.city}, {data.country}</h3>
                            </div>
                        </div>
                    </>)
                }
            </div>
        </div >
    );
};

export default Contact;